import Component from 'flarum/common/Component';
import HeaderSlideShowView from './HeaderSlideShowView';
import NavigationBar from './NavigationBar';

export default class HeaderView extends Component {
  oninit(vnode) {
    super.oninit(vnode);

    this.bodyClass = 'App--page';
    this.loading = true;
    // app.store.find('headSlideShow').then(() => {
    //   this.loading = false;
    //   m.redraw();
    //   const categories = app.store.all('headSlideShowCategories').sort((a, b) => a.id() - b.id());
    //   new Carousel(document.querySelector('.carousel'), categories[0].transitionTime() * 1000) || 5000;
    // });
  }
  view() {
    return (
      <div>
        <NavigationBar />
        <HeaderSlideShowView  />
      </div>
    );
  }
}
